<div class="contenedor" >
  <h2> 📦 AGREGAR PRODUCTOS DESDE IMPERIUM POR FACTURA </h2>
<div class="filtros">

    <div class="filtro-item">
      <label><strong> COMPROB. NRO: </strong></label>
      <input type="text" placeholder="COMPROB.NRO" />
    </div>

    <div class="filtro-item">
      <input type="text" placeholder="Buscar..." [formControl]="searchControl"/>
    </div>

    <div class="filtro-item">
          <button> Encontrar </button>                                                
    </div>
</div>

<div class="filtros">
    <div class="filtro-item">
      <label>Buscar por:</label>
        <select>
          <option value="descripcion">DESCRIPCION</option>
          <option value="codigo_imperium">COD IMPERIUM</option>
        </select>
    </div>
    <div class="filtro-item">
      <input [formControl]="searchControl" placeholder="Buscar..."/>
    </div>
</div>

<form class="contenedor1">
  <div class="formulario">
    <p><strong>FECHA DE FACTURA:</strong> {{ factura?.fecha_emision }}</p>
    <p><strong>NRO COMPROBANTE:</strong> {{ factura?.factura_nro }}</p>
    <p><strong>PROVEEDOR:</strong> {{ factura?.proveedor?.nombre }} ({{ factura?.proveedor?.ruc }})</p>
  </div>
</form>

  
  <div class="paginacion">
    <button>
      ⬅️ Anterior
    </button>
    <samp> Página  1  de  37 </samp>
    <button>
      Siguiente ➡️
    </button>
  </div>

  <div class="tabla-contenedorr">
    <table class="product-table">
      <thead>
        <tr>
          <th>ITEM</th>
          <th (click)="sortItems('codigo_imperium')">COD_IMPERIUM</th>
          <th (click)="sortItems('codigo_barra')">COD_BARRAS</th>
          <th (click)="sortItems('producto')">DESCRIPCION</th>
          <th (click)="sortItems('valor_unitario')">VALOR</th>
          <th (click)="sortItems('cantidad')">CANTIDAD</th>
          <th>ACCIONES</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of pagedItems(); let i = index">
          <td>{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
          <td>{{ item.codigo_imperium }}</td>
          <td>{{ item.codigo_barra }}</td>
          <td>{{ item.producto }}</td>
          <td>{{ item.valor_unitario | number:'1.2-2' }}</td>
          <td>{{ item.cantidad }}</td>
          <td><button class="agreButton" (click)="agregarAlInventario(item)"> AGREGA A INVENTARIO</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>





